
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { Home } from './vitrine/pages/Home';
import { About } from './vitrine/pages/About';
// import CreateAdminAccount from './admin/pages/CreateAdminAccount';
// import DashboardApp from './admin/pages/Dashboard/DashboardApp';
// import EntrepriseDashboard from './admin/pages/Dashboard/DashboarEntreprise/EntrepriseDashboard';
import OauthRedirectHandler from './admin/pages/Dashboard/DashboarEntreprise/OauthRedirectHandler';
import SettingApp from './admin/pages/Dashboard/DashboarEntreprise/SettingApp';
// import HomePage from './admin/pages/HomePage';  des test du départ 
import FAQ from './vitrine/Components/FAQ';
import Articles from './vitrine/pages/Article/Articles';
import BecomeClient from './vitrine/pages/BecomeClient/BecomeClient';
import { Sales } from './vitrine/pages/Sales';
import SearchPage from './vitrine/pages/SearchPage';
import Support from './vitrine/pages/Support';
import Contact from './vitrine/pages/Contact';
// import Users from './admin/pages/Dashboard/Users';
import { QueryClient, QueryClientProvider } from 'react-query';
// import EntrepriseDashboard from './admin/components/EntrepriseDashboard';
import AdminPage from './admin/pages/Dashboard/DashboarEntreprise/AdminPage';
import Settings from './admin/pages/Dashboard/Settings';
import PrivateRoute from './PrivateRoute'; 
import NotFound from './NotFound';
import AxiosInterceptor from './admin/pages/Dashboard/DashboarEntreprise/AxiosInterceptor';
import {RolesPage} from './admin/components/applications/Roles/RolePage';
import DashboardApp from './admin/components/applications/Users/DashboardApp';
import Users from './admin/components/applications/Users/Users';
// import UserForm from './admin/components/applications/Users/UserForm';
import { TranslationProvider } from './TranslationContext';
import { ThemeProvider } from './admin/pages/Dashboard/DashboarEntreprise/ThemeContext';
import LandingPage from './admin/components/Landin/Landing';
import EntrepriseDashboard from './admin/components/EntrepriseDashboard';
import { logout } from './vitrine/services/Apivitrine';
import TicketDetail from './vitrine/pages/TicketDetail';

const queryClient = new QueryClient();

function App() {

  return (
  
    <BrowserRouter basename="/">

<AxiosInterceptor logout={logout} />
 <TranslationProvider>
 <ThemeProvider>



      <QueryClientProvider client={queryClient}>
        <Routes>
          {/* Vitrine App Routes (Publiques) */}
          <Route path="/" element={<Home />} />
          <Route path="/About" element={<About />} />
          <Route path="/Sales" element={<Sales />} />
          <Route path="/Articles" element={<Articles />} />
          <Route path="/SearchPage" element={<SearchPage />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/BecomeClient" element={<BecomeClient />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/support" element={<Support />} />
          {/* <Route path="/Ticketdetails" element={< TicketDetail/>} /> */}
          <Route path="/support/ticket/:ticketId" element={<TicketDetail />} />
          
        


          {/* Admin App Routes (Privées) */}
          {/* <Route  path="/admin"  element={<PrivateRoute>  <HomePage /> </PrivateRoute>  }/> */} testde départ 
         {/* <Route path="/CreateAdminAccount"element={<PrivateRoute>  <CreateAdminAccount /></PrivateRoute>  }  /> */}
           <Route path="/Callback"element={ <OauthRedirectHandler />}/>
          {/* <Route  path="/EntrepriseDashboard" element={ <PrivateRoute>  <EntrepriseDashboard /> </PrivateRoute> }/> */}
          {/* <Route path="/application/:appId" element={<PrivateRoute><DashboardApp /></PrivateRoute> } /> */}
          {/* <Route path="/HomeAdmin" element={<PrivateRoute> <LandingPage /></PrivateRoute>} /> */}
          <Route path="/HomeAdmin" element={ <LandingPage />} />
          <Route  path="/EntrepriseDashboard" element={<PrivateRoute> <EntrepriseDashboard/> </PrivateRoute>}/>
        {/* <Route  path="/EntrepriseDashboard" element={ <EntrepriseDashboard/>}/> */}
        <Route path="/application/:appId" element={<PrivateRoute><DashboardApp /></PrivateRoute> } />

          <Route path="/AdminPage"element={<PrivateRoute><AdminPage /> </PrivateRoute> }/>
          <Route path="/Settings"element={<PrivateRoute><Settings /> </PrivateRoute>  } />
          {/* <Route path="/application/:appId/Users"element={<PrivateRoute><Users /> </PrivateRoute> } /> */}
          <Route path="/application/:appId/SettingApp"element={<PrivateRoute><SettingApp /></PrivateRoute>}  />
          <Route path="/application/:appId/Roles" element={<PrivateRoute><RolesPage /></PrivateRoute>} />
         
         <Route path="/application/:appId/Users"element={<PrivateRoute><Users /> </PrivateRoute> } /> 
    
          <Route path="*" element={<NotFound />} />
        </Routes>
      </QueryClientProvider>
      </ThemeProvider>
      </TranslationProvider>
    </BrowserRouter>
  );
}

export default App;





// import { Routes, Route, BrowserRouter} from 'react-router';
// import {Home} from './vitrine/pages/Home';
// import {About} from './vitrine/pages/About';


// import CreateAdminAccount from './admin/pages/CreateAdminAccount';
// import DashboardApp from './admin/pages/Dashboard/DashboardApp';
// import EntrepriseDashboard from './admin/pages/Dashboard/DashboarEntreprise/EntrepriseDashboard';
// import OauthRedirectHandler from './admin/pages/Dashboard/DashboarEntreprise/OauthRedirectHandler';
// import SettingApp from './admin/pages/Dashboard/DashboarEntreprise/SettingApp';
// import HomePage from './admin/pages/HomePage';
// import FAQ from './vitrine/Components/FAQ';
// import Articles from './vitrine/pages/Article/Articles';
// import BecomeClient from './vitrine/pages/BecomeClient/BecomeClient';
// import {Sales} from './vitrine/pages/Sales';
// import SearchPage from './vitrine/pages/SearchPage';
// import Support from './vitrine/pages/Support';
// // import { QueryClient, QueryClientProvider } from 'react-query';
// // import { ApplicationProvider } from './admin/pages/Dashboard/DashboarEntreprise/ApplicationContext';
// import Contact from './vitrine/pages/Contact';
// //import Settings from './admin/pages/Dashboard/Settings';
// import Users from './admin/pages/Dashboard/Users';
// // import { ApplicationProvider } from './admin/pages/Dashboard/DashboarEntreprise/ApplicationContext';
// import { QueryClient, QueryClientProvider } from 'react-query';
// import AdminPage from './admin/pages/Dashboard/DashboarEntreprise/AdminPage';
// import Settings from './admin/pages/Dashboard/Settings';

// // import { TranslationProvider } from './TranslationContext';

// const queryClient = new QueryClient();

// function App() {

  
//   return (
//     <BrowserRouter basename='/'>
//     <QueryClientProvider client={queryClient}>
    
   
    
//     <Routes>
   
  
//       {/* Vitrine App Routes */}
//          <Route path="/" element={<Home />} />
//         <Route path="/About" element={<About />} />
//         <Route path="/Sales" element={<Sales />} />
//         <Route path="/Articles" element={<Articles />} />
//         <Route path="/SearchPage" element={<SearchPage />} />
//         <Route path="/Contact" element={<Contact />} />
//         <Route path="/BecomeClient" element={<BecomeClient />} />
//         <Route path="/faq" element={<FAQ />} />
//         <Route path="/support" element={<Support />} /> 
        
//        {/* Admin App Routes pour l'administration */} 

     
       

//           <Route path='/admin' element={<HomePage />} />
//           {/* <Route path="/Login" element={<Login />} /> */}
//           <Route path='/CreateAdminAccount' element={<CreateAdminAccount />}/>         
//           <Route path='/Callback' element={<OauthRedirectHandler />} />
//           <Route path='/EntrepriseDashboard' element={<EntrepriseDashboard />} />
//           <Route path='/application/:appId' element={<DashboardApp />} />
//           <Route path='/AdminPage' element={<AdminPage/>} />

//           <Route path='/Settings' element={<Settings />} />
//           <Route path='/application/:appId/Users' element={<Users/>} />
//           <Route path='/application/:appId/SettingApp' element={<SettingApp />} /> 
        
          
       
//                {/* <Route path='*' element={<Navigate to="/" replace />} /> */}
//   </Routes>
 
  


//    </QueryClientProvider>
//    </BrowserRouter>
  
//   );
// }

// export default App;
